<template>
  <div id="footer" class="acea-row row-middle">
    <div class="copyright">©2019-2025 樂雅健康管理系统 All right reserved</div>
  </div>
</template>
<style scoped>
.copyright {
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  color: #CCCCCC;
  line-height: 36px;
  opacity: 0.6;
}
</style>
<script>
export default {
  name: "Footer",
  props: {
    beian: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      footerList: [
        {
          name: "首页",
          icon1: "icon-shouye-xianxing",
          icon2: "icon-shouye",
          url: "/"
        },
        {
          name: "分类",
          icon1: "icon-yingyongchengxu-xianxing",
          icon2: "icon-yingyongchengxu",
          url: "/category"
        },
        {
          name: "购物车",
          icon1: "icon-caigou-xianxing",
          icon2: "icon-caigou",
          url: "/cart"
        },
        {
          name: "我的",
          icon1: "icon-yonghu-xianxing",
          icon2: "icon-yonghu",
          url: "/user"
        }
      ]
    };
  },
  methods: {}
};
</script>
